<template>
<v-card>
    <v-card-text>

      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
        <v-row>
          <v-col
            cols="9"
          >
            <ValidationProvider>
              <vue2Dropzone
                class="mt-5"
                v-on:vdropzone-success="addFile"
                v-on:vdropzone-sending="sendingEvent"
                :options="dropzoneOptions">
              </vue2Dropzone>
            </ValidationProvider>
          </v-col>
          <v-col
            cols="3"
          >
            <p>
              <b>In questa sezione va caricato un file csv con le seguenti colonne separate da ;</b>
              <br>
              "CodScuola";"NomeScuola";"Indirizzo";"Cap";"Comune";"Provincia";"Descrizione";"Materia";"CodISBN";"Autore";"DEPAR";"Editore";"EURO";"Classe";"Sezione";"Alunni";"Consigliato";"NuovaAdozione";"DaAcquistare";"AnnoAdo";"Tipoligia";"Sub Agente"
            </p>
          </v-col>
        </v-row>


    </ValidationObserver>

    </v-card-text>

  </v-card>
</template>

<script>
  import { mapActions } from 'vuex';


  import vue2Dropzone from 'vue2-dropzone';
  import MessageModal from '../../components/modals/shared/MessageModal.vue';
  import 'vue2-dropzone/dist/vue2Dropzone.min.css';

  import { adoptionsService } from '../../utils/services/adoptions.service';
  import { routeNames } from '../../config/router/routeNames';
  import api from '../../utils/services/api.service';

  export default {
    name: 'AdoptionImport',
    components: {
      vue2Dropzone,
    },
    props: {

    },
    data() {
      return {

        form: {
          file: 0,
        },
        loading: false,
        dropzoneOptions: {
          url: `${api.getApiUrl()}/files`,
          thumbnailWidth: 200,
          addRemoveLinks: true,
          headers: { Authorization: localStorage.getItem('auth-token') },
        },
        errors: undefined,
      };
    },

    computed: {

    },

    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['showModal', 'hideModal']),

      showLoadingMessage(title, message) {
        this.showModal({
          component: MessageModal,
            data: {
              stored: {
                title,
                message,
              },
          },
        });
      },

      sendingEvent(file, XMLHttpRequest, formData) {
        formData.append('name', file.name);
      },

      showErrorMessage(errors) {
        let message = '';
        let content = '';

        if (Object.keys(errors.schools).length) {
          message += `<div><b>SCUOLE NON TROVATE: ${Object.keys(errors.schools).length}</b></div>`;
          Object.keys(errors.schools).forEach(item => {
            console.log(errors.schools[item]);
            message += `<div>${errors.schools[item]}</div>`;
            content += `${errors.schools[item]}`;
          });
        }

        if (Object.keys(errors.books).length) {
          message += `<div><b>LIBRI NON TROVATI: ${Object.keys(errors.books).length}</b></div>`;
          Object.keys(errors.books).forEach(item => {
              message += `<div>${errors.books[item]}</div>`;
              content += `${errors.books[item]}`;
          });
        }

        this.showLoadingMessage('Esito importazione', message);


        const link = document.createElement('a');
        const filelog = new Blob([content], { type: 'text/plain' });
        link.href = URL.createObjectURL(filelog);
        link.download = 'log.txt';
        link.click();
        URL.revokeObjectURL(link.href);
      },

      async addFile(file, response) {
        this.form.file = response.file.id;
        await adoptionsService.save(this.form)
        .then(async (res) => {
          this.loading = false;
          if (
              Object.keys(res.data.errors.schools).length
              || Object.keys(res.data.errors.books).length
          ) {
            this.showErrorMessage(res.data.errors);
            this.$router.push({ name: routeNames.ADOPTION });
}
        })
        .catch(error => {
            this.loading = false;
            console.log(error);
            this.handleError(error, this.errors);
        });
      },

    },


  };
</script>

<style>


</style>
